import { blue, deepOrange, purple, teal } from '@mui/material/colors';
import { Chip as MuiChip } from '@mui/material';
import { AccountGroupRole } from '@shared/enums';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface CustomerRoleBadgeProps {
  accountGroupRole: AccountGroupRole,
  testID?: string,
}

const RoleBadge = ({ role, testID }: { role: AccountGroupRole, testID?: string }) => {
  const { t } = useTranslation();
  
  const getRoleConfig = (customerRole: AccountGroupRole) => {
    switch (customerRole) {
      case AccountGroupRole.Primary:
        return {
          backgroundColor: blue[800],
          label: t($ => $.customerDashboard.accountRoles.primary),
        };
      case AccountGroupRole.Secondary:
        return {
          backgroundColor: teal[800],
          label: t($ => $.customerDashboard.accountRoles.secondary),
        };
      case AccountGroupRole.Partner:
        return {
          backgroundColor: purple[500],
          label: t($ => $.customerDashboard.accountRoles.partner),
        };
      case AccountGroupRole.IndependentPartner:
        return {
          backgroundColor: deepOrange[900],
          label: t($ => $.customerDashboard.accountRoles.independentPartner),
        };
      default:
        return null;
    }
  };
  
  const config = getRoleConfig(role);
  
  if (!config) {
    return null;
  }
  
  return (
    <MuiChip
      data-testid={testID}
      label={config.label}
      sx={{
        alignItems: 'center',
        backgroundColor: config.backgroundColor,
        borderRadius: '20px',
        color: '#FFFFFF',
        fontSize: '11px',
        fontWeight: 500,
        gap: '4px',
        height: '16px',
        justifyContent: 'center',
        letterSpacing: '1px',
        lineHeight: '13px',
        padding: '0 8px',
        textTransform: 'uppercase',
        '& .MuiChip-label': {
          padding: '0',
        },
      }}
    />
  );
};

export const CustomerRoleBadge = ({
  accountGroupRole,
  testID,
}: CustomerRoleBadgeProps) => {

  if (accountGroupRole === AccountGroupRole.Primary) {
    return <RoleBadge role={AccountGroupRole.Primary} testID={testID} />;
  } else if (accountGroupRole === AccountGroupRole.Secondary) {
    return <RoleBadge role={AccountGroupRole.Secondary} testID={testID} />;
  } else if (accountGroupRole === AccountGroupRole.Partner) {
    return <RoleBadge role={AccountGroupRole.Partner} testID={testID} />;
  } else if (accountGroupRole === AccountGroupRole.IndependentPartner) {
    return <RoleBadge role={AccountGroupRole.IndependentPartner} testID={testID} />;
  }
  return null;
};
